import * as React from 'react';
import { TeamListViewBase } from './TeamListViewBase';
import { BaseRouteProps } from '../../../interfaces';
import { UserStore, FilterStore } from '../../../stores';

interface TeamListViewReportProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

export class TeamListViewReport extends React.Component<TeamListViewReportProps, {}> {
    public render() {
        return <TeamListViewBase 
            {...this.props} 
            title="PVA Team List View" 
            numColumns={3} 
            showResponseIndicator={false} 
        />;
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/teamListView/TeamListViewReport.tsx